













import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'IconUsp',
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    url: {
      type: String,
      default: '#'
    },
    target: {
      type: String,
      default: '_blank'
    },
    html: {
      type: String,
      default: ''
    }
  }
});
